import { Masonry, TabContext, TabList, TabPanel } from '@mui/lab'
import { Box, Card, CardContent, Grid, Tab } from '@mui/material'
import { useAuth, useLayout } from 'context'
import * as controllers from 'controllers'
import {
  MichiganTitleDto,
  VehicleCheckInAirbagTellTalePhotoDto,
  VehicleCheckInBackupCamPhotoDto,
  VehicleCheckInCheckInClusterPhotoDto,
  VehicleCheckInClusterWithOdometerPhotoDto,
  VehicleCheckInComboPhotoDto,
  VehicleCheckInDetailsDto,
  VehicleCheckInDriverAirbagPhotoDto,
  VehicleCheckInFrontCornerPhotoDto,
  VehicleCheckInFrontHeadOnPhotoDto,
  VehicleCheckInImporterDoorLabelPhotoDto,
  VehicleCheckInManufacturersLabelPhotoDto,
  VehicleCheckInPassengerAirbagPhotoDto,
  VehicleCheckInRearCornerPhotoDto,
  VehicleCheckInRearHeadOnPhotoDto,
  VehicleCheckInRoofPhotoDto,
  VehicleCheckInTirePressureLabelPhotoDto,
  VehicleCheckInTPMSPhotoDto,
  VehicleCheckInVINOnDashboardPhotoDto,
  VehicleDto
} from 'dtos'
import React, { useEffect, useState } from 'react'
import { useParams } from 'react-router-dom'
import ActivityLogDetailsCard from './ActivityLogDetailsCard'
import BondEmailSentListCard from './BondEmailSentListCard'
import BondInformationListCard from './BondInformationListCard'
import BondSpecialRequestCard from './BondSpecialRequestCard'
import ClusterIncorrectMileageResolution from './ClusterIncorrectMileageResolutionCard'
import ClusterInformationListCard from './ClusterInformationListCard'
import ClusterPhotosListCard from './ClusterPhotosListCard'
import ClusterTimeline from './ClusterTimeline'
import DamageDetailsListCard from './DamageDetailsListCard'
import DocumentDetailsCard from './DocumentDetailsCard'
import ExporterInformationListCard from './ExporterInformationListCard'
import ExporterNotesListCard from './ExporterNotesListCard'
import ExporterPhotoListCard from './ExporterPhotoListCard'
import ImporterNotesCard from './ImporterNotesListCard'
import InvoicingDetailsCard from './InvoicingDetailsCard'
import LabelDetailsCard from './LabelsDetailsCard'
import ManufacturerLabelCard from './ManufacturerLabelCard'
import RecallCampaignListCard from './RecallCampaignListCard'
import RecallNotesListCard from './RecallNotesListCard'
import ReferenceDetailsCard from './ReferenceDetailsCard'
import TirePressureLabelCard from './TirePressureLabelCard'
import TransactionsDetailsCard from './TransactionsDetailsCard'
import VehicleCheckInCheckInPhotosCard from './VehicleCheckInCheckInPhotosCard'
import VehicleCheckInDetailsCard from './VehicleCheckInDetailsCard'
import VehicleDetailsCard from './VehicleDetailsCard'
import VehicleStatusCheckListDetailsCard from './VehicleStatusCheckListDetailsCard'
import ConformityTab from './tabs/conformity'
import TitleTab from './tabs/title'

export interface VehicleCheckInCheckInPhotosProps {
  manufacturersLabelPhoto: VehicleCheckInManufacturersLabelPhotoDto
  setManufacturersLabelPhoto: React.Dispatch<React.SetStateAction<VehicleCheckInManufacturersLabelPhotoDto>>
  tirePressureLabelPhoto: VehicleCheckInTirePressureLabelPhotoDto
  setTirePressureLabelPhoto: React.Dispatch<React.SetStateAction<VehicleCheckInTirePressureLabelPhotoDto>>
  importerDoorLabelPhoto: VehicleCheckInImporterDoorLabelPhotoDto
  setImporterDoorLabelPhoto: React.Dispatch<React.SetStateAction<VehicleCheckInImporterDoorLabelPhotoDto>>
  comboPhoto: VehicleCheckInComboPhotoDto
  setComboPhoto: React.Dispatch<React.SetStateAction<VehicleCheckInComboPhotoDto>>
  checkInClusterPhoto: VehicleCheckInCheckInClusterPhotoDto
  setCheckInClusterPhoto: React.Dispatch<React.SetStateAction<VehicleCheckInCheckInClusterPhotoDto>>
  clusterWithOdometerPhoto: VehicleCheckInClusterWithOdometerPhotoDto
  setClusterWithOdometerPhoto: React.Dispatch<React.SetStateAction<VehicleCheckInClusterWithOdometerPhotoDto>>
  tpmsPhoto: VehicleCheckInTPMSPhotoDto
  setTPMSPhoto: React.Dispatch<React.SetStateAction<VehicleCheckInTPMSPhotoDto>>
  driverAirbagPhoto: VehicleCheckInDriverAirbagPhotoDto
  setDriverAirbagPhoto: React.Dispatch<React.SetStateAction<VehicleCheckInDriverAirbagPhotoDto>>
  backupCamPhoto: VehicleCheckInBackupCamPhotoDto
  setBackupCamPhoto: React.Dispatch<React.SetStateAction<VehicleCheckInBackupCamPhotoDto>>
  airbagTellTalePhoto: VehicleCheckInAirbagTellTalePhotoDto
  setAirbagTellTalePhoto: React.Dispatch<React.SetStateAction<VehicleCheckInAirbagTellTalePhotoDto>>
  passengerAirbagPhoto: VehicleCheckInPassengerAirbagPhotoDto
  setPassengerAirbagPhoto: React.Dispatch<React.SetStateAction<VehicleCheckInPassengerAirbagPhotoDto>>
  vinOnDashboardPhoto: VehicleCheckInVINOnDashboardPhotoDto
  setVinOnDashboardPhoto: React.Dispatch<React.SetStateAction<VehicleCheckInVINOnDashboardPhotoDto>>
  roofPhoto: VehicleCheckInRoofPhotoDto
  setRoofPhoto: React.Dispatch<React.SetStateAction<VehicleCheckInRoofPhotoDto>>
  frontCornerPhoto: VehicleCheckInFrontCornerPhotoDto
  setFrontCornerPhoto: React.Dispatch<React.SetStateAction<VehicleCheckInFrontCornerPhotoDto>>
  frontHeadOnPhoto: VehicleCheckInFrontHeadOnPhotoDto
  setFrontHeadOnPhoto: React.Dispatch<React.SetStateAction<VehicleCheckInFrontHeadOnPhotoDto>>
  rearCornerPhoto: VehicleCheckInRearCornerPhotoDto
  setRearCornerPhoto: React.Dispatch<React.SetStateAction<VehicleCheckInRearCornerPhotoDto>>
  rearHeadOnPhoto: VehicleCheckInRearHeadOnPhotoDto
  setRearHeadOnPhoto: React.Dispatch<React.SetStateAction<VehicleCheckInRearHeadOnPhotoDto>>
}

export default function VehiclesId() {
  const { id, tab, vehicleGuid } = useParams()
  const layout = useLayout()
  const {
    permissions: { INVOICES_ADD_EDIT }
  } = useAuth()
  const [isGettingVehicle, setIsGettingVehicle] = useState<boolean>(false)
  const [vehicle, setVehicle] = useState<VehicleDto>(new VehicleDto())
  const [michiganTitle, setMichiganTitle] = useState<MichiganTitleDto | null>(null)
  const [initialValues, setInitialValues] = useState<VehicleCheckInDetailsDto>(new VehicleCheckInDetailsDto())

  // If this works, this should be refactored into a VehicleCheckInTab component.
  // Maxwell Sommer 02/18/2025
  const [refreshManufacturerLabel, setRefreshManufacturerLabel] = useState<number>(0)
  const [refreshTirePressureLabel, setRefreshTirePressureLabel] = useState<number>(0)

  const [value, setValue] = useState<string>('exporter')
  const handleChange = (event: React.SyntheticEvent, newValue: string) => {
    setValue(newValue)
  }

  const [selectedDamageGuid, setSelectedDamageGuid] = useState<string | null>(null)

  useEffect(() => {
    if (id && id.toLowerCase() !== 'undefined' && id.toLowerCase() !== 'new') {
      setIsGettingVehicle(true)
      controllers
        .getVehicleById(id)
        .then(response => {
          setVehicle(response.value)
        })
        .finally(() => {
          setIsGettingVehicle(false)
        })
    }
  }, [id])

  useEffect(() => {
    if (!vehicle?.vehicleGuid) return

    controllers
      .getMichiganTitleByVehicleGuid(vehicle.vehicleGuid)
      .then(r => setMichiganTitle(r.value))
      .catch(() => setMichiganTitle(null))
  }, [vehicle?.vehicleGuid])

  // This useEffect is used to allow for each menu in the vehicleid, to be included in the navigation URL, ex. vehicles/:id/exporter
  useEffect(() => {
    setValue(tab ?? 'exporter')
  }, [tab])

  return (
    <Grid container spacing={1} alignItems='flex-start' key={vehicle.vehicleGuid}>
      <Grid item xs={12}>
        <VehicleDetailsCard vehicle={vehicle} setVehicle={setVehicle} />
      </Grid>

      <Grid item xs={12}>
        <Card>
          <CardContent>
            <TabContext value={value}>
              <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                <TabList onChange={handleChange} variant='scrollable' scrollButtons='auto'>
                  <Tab label='EXPORTER' value='exporter' />

                  <Tab label='BOND' value='bond' />

                  <Tab label='DOCUMENTS' value='documents' />

                  <Tab label='RECALL' value='recall' />

                  <Tab label='CLUSTER' value='cluster' />

                  <Tab label='TITLE' value='title' />

                  <Tab label='CONFORMITY' value='conformity' />

                  <Tab label='DAMAGE' value='damage' />

                  {INVOICES_ADD_EDIT && <Tab label='INVOICING' value='invoicing' />}

                  <Tab label='VEHICLE STATUS CHECKLIST' value='vehicle-status-checklist' />

                  <Tab label='IMPORTER NOTES' value='importer-notes' />

                  <Tab label='VEHICLE CHECK-IN' value='vehicle-check-in' />

                  <Tab label='ACTIVTY LOG' value='activity-log' />

                  <Tab label='LABELS' value='labels' />
                </TabList>
              </Box>

              <TabPanel value='exporter'>
                <Masonry columns={2} sequential sx={{ margin: 0 /* this should be in the theme, otherwise it doesn't line up with hero card. */ }}>
                  <ExporterInformationListCard vehicle={vehicle} />

                  <ExporterPhotoListCard vehicle={vehicle} />

                  <ExporterNotesListCard vehicle={vehicle} />
                </Masonry>
              </TabPanel>

              <TabPanel value='bond'>
                <Masonry columns={2} sequential sx={{ margin: 0 /* this should be in the theme, otherwise it doesn't line up with hero card. */ }}>
                  <BondInformationListCard vehicle={vehicle} />

                  <BondSpecialRequestCard vehicle={vehicle} />
                </Masonry>

                <Masonry columns={1} sequential sx={{ margin: 0 /* this should be in the theme, otherwise it doesn't line up with hero card. */ }}>
                  <BondEmailSentListCard vehicle={vehicle} />
                </Masonry>
              </TabPanel>

              <TabPanel value='documents'>
                <Grid item xs={12}>
                  <DocumentDetailsCard vehicle={vehicle} />
                </Grid>
              </TabPanel>

              <TabPanel value='recall'>
                <Grid container spacing={1}>
                  <Grid item xs={12}>
                    <RecallCampaignListCard vehicle={vehicle} />
                  </Grid>

                  <Grid item xs={12}>
                    <RecallNotesListCard vehicle={vehicle} />
                  </Grid>
                </Grid>
              </TabPanel>

              <TabPanel value='cluster'>
                <Masonry columns={2} sequential sx={{ margin: 0 /* this should be in the theme, otherwise it doesn't line up with hero card. */ }}>
                  <ClusterInformationListCard vehicle={vehicle} />
                  <ClusterPhotosListCard vehicle={vehicle} />
                  <ClusterIncorrectMileageResolution vehicle={vehicle} />
                  <ClusterTimeline vehicle={vehicle} />
                </Masonry>
              </TabPanel>

              <TabPanel value='title'>
                <TitleTab vehicleGuid={vehicle?.vehicleGuid} />
              </TabPanel>

              <TabPanel value='conformity'>
                <ConformityTab vehicleGuid={vehicle?.vehicleGuid} />
              </TabPanel>

              <TabPanel value='damage'>
                <Grid item xs={12}>
                  <DamageDetailsListCard vehicle={vehicle} onEditDamage={guid => setSelectedDamageGuid(guid)} />
                </Grid>
              </TabPanel>

              {INVOICES_ADD_EDIT && (
                <TabPanel value='invoicing'>
                  <Box
                    sx={{
                      width: '100%',
                      display: 'flex',
                      gap: 3,
                      alignItems: 'flex-start'
                    }}
                  >
                    <Box sx={{ flexBasis: '30%' }}>
                      <InvoicingDetailsCard vehicle={vehicle} />
                    </Box>
                    <Box sx={{ flexBasis: '20%' }}>
                      <ReferenceDetailsCard vehicle={vehicle} />
                    </Box>
                    <Box sx={{ flexBasis: '50%' }}>
                      <TransactionsDetailsCard vehicle={vehicle} />
                    </Box>
                  </Box>
                </TabPanel>
              )}

              <TabPanel value='vehicle-status-checklist'>
                <Grid item xs={12} sm={6}>
                  <VehicleStatusCheckListDetailsCard vehicle={vehicle} />
                </Grid>
              </TabPanel>

              <TabPanel value='importer-notes'>
                <Grid container spacing={1}>
                  <Grid item xs={12}>
                    <ImporterNotesCard vehicle={vehicle} />
                  </Grid>
                </Grid>
              </TabPanel>

              <TabPanel value='vehicle-check-in'>
                <Masonry columns={2} sequential sx={{ margin: 0 /* this should be in the theme, otherwise it doesn't line up with hero card. */ }}>
                  <Box>
                    <VehicleCheckInDetailsCard vehicle={vehicle} />

                    <Box sx={{ mt: 2, display: 'grid', gridTemplateColumns: 'repeat(2, 1fr)', gap: 2 }}>
                      <ManufacturerLabelCard vehicle={vehicle} key={refreshManufacturerLabel} />

                      <TirePressureLabelCard vehicle={vehicle} key={refreshTirePressureLabel} />
                    </Box>
                  </Box>

                  <VehicleCheckInCheckInPhotosCard
                    vehicle={vehicle}
                    refreshManufacturerLabel={() => {
                      setRefreshManufacturerLabel(prev => prev + 1)
                    }}
                    refreshTirePressureLabel={() => {
                      setRefreshTirePressureLabel(prev => prev + 1)
                    }}
                  />
                </Masonry>
              </TabPanel>

              <TabPanel value='activity-log'>
                <Grid item xs={12}>
                  <ActivityLogDetailsCard vehicle={vehicle} />
                </Grid>
              </TabPanel>

              <TabPanel value='labels'>
                <Grid item xs={12} sm={12}>
                  <LabelDetailsCard vehicle={vehicle} id={id} />
                </Grid>
              </TabPanel>
            </TabContext>
          </CardContent>
        </Card>
      </Grid>
    </Grid>
  )
}
